import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalService = inject(MsalService);

  async canActivate(): Promise<boolean | UrlTree> {
    // Attendre que MSAL ait un compte actif

    // Vérifie session côté API
    try {
      await firstValueFrom(this.authService.checkSession());
    } catch {
      return this.router.createUrlTree(['/login']);
    }

    return true;
  }

}
